import { useInfoContext } from "hooks/useInfo";
import "./flood_selector.css";
import { useIsTouchDevice } from "hooks/useIsTouchDevice";
import { Headline } from "components/typography";
import { useAnalyticsHandler } from "hooks/useAnalytics";

export type CircleSelectorKeys =
  | "None"
  | "flooding_1996"
  | "flooding_latest"
  | "flooding_nomang";

type CircleSelectorStyles = Record<CircleSelectorKeys, string>;

const styles: CircleSelectorStyles = {
  None: "None",
  flooding_1996: "1996",
  flooding_latest: "With Mangroves",
  flooding_nomang: "Without Mangroves",
};

const CircleSelector = ({
  thisFloodgroup,
  setFloodGroup,
}: {
  thisFloodgroup: string;
  setFloodGroup: (floodGroup: string) => void;
}) => {
  const floodGroupChangedHandler = useAnalyticsHandler("Flood Group Changed");
  return (
    <div
      className="circle-selector-container flooding"
      onClick={() => {
        setFloodGroup(thisFloodgroup);
        floodGroupChangedHandler({
          floodGroup: thisFloodgroup,
          floodGroupLabel: styles[thisFloodgroup as CircleSelectorKeys],
        });
      }}
    >
      <Headline level={5} className="circle-selector-text text-white flooding">
        {styles[thisFloodgroup as CircleSelectorKeys]}
      </Headline>
    </div>
  );
};

export const FloodSelector = ({
  floodGroup,
  setFloodGroup,
  floodingOn,
  position,
}: {
  floodGroup: string;
  setFloodGroup: (floodGroup: string) => void;
  floodingOn: boolean;
  position: "left" | "right";
}) => {
  // @ts-ignore not ready to type InfoContext yet
  const { useFirst } = useInfoContext();
  const isTouchDevice = useIsTouchDevice();
  useFirst(() => !!floodingOn, "FIRST_FLOODING");

  const offset = position === "left" ? "right" : "left";

  // Don't show desktop flood selectors on mobile - let mobile flood selector handle it
  if (isTouchDevice) {
    return null;
  }

  return (
    <>
      {floodingOn ? (
        <div
          className="floodgroup-manager-outer-container"
          style={{
            position: "absolute",
            bottom: "20px",
            [offset]: "1px",
          }}
        >
          <div className="floodgroup-manager-inner-container">
            <CircleSelector
              thisFloodgroup={floodGroup}
              setFloodGroup={setFloodGroup}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};
